import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router'

import * as R from 'ramda'

import MenuItem from 'material-ui/MenuItem';

import Combobox from 'components/Combobox'

import dataActions from 'actions/dataActions'

import { doc, dirtyRead } from '../selectors/common'
import { vendors, properties } from '../selectors/entities'

import { sortSev } from 'utils/stuff'

let select = dirtyRead(
	(state, props) => ({
		object: doc(state, props.objectID)
	  , party: doc(state, doc(state, props.objectID).partyID || doc(state, props.objectID).vendorID )
	  , parties: vendors(state)
	  , properties: properties(state)
	})
)

const cats = [
	{subtype: "advertising", name: "Advertising", req: "70000 Property Expenses:70010 Advertising"},
	{subtype: "apps", name: "Appliances", req: "70000 Property Expenses:70020 Appliances"},
	{subtype: "cnm", name: "Cleaning and maintenance", req: "70000 Property Expenses:70030 Cleaning and maintenance"},
	{subtype: "hoa", name: "HOA fees", req: "70000 Property Expenses:70040 HOA fees"},
	{subtype: "insurance", name: "Insurance", req: "70000 Property Expenses:70050 Insurance"},
	{subtype: "legal", name: "Legal and Other fees", req: "70000 Property Expenses:70060 Legal and Other fees"},
	{subtype: "management", name: "Management fees", req: "70000 Property Expenses:70070 Management fees"},
	{subtype: "misc", name: "Miscellaneous", req: "70000 Property Expenses:70080 Miscellaneous"},
	{subtype: "loan", name: "Mortgage interest", req: "70000 Property Expenses:70090 Mortgage interest"},
	{subtype: "loan", name: "Mortgage principle", req: "70000 Property Expenses:70100 Mortgage principle"},
	{subtype: "repair", name: "Repair", req: "70000 Property Expenses:70110 Repair"},
	{subtype: "taxes", name: "Taxes", req: "70000 Property Expenses:70120 Taxes"},
	{subtype: "utilities", name: "Utilities", req: "70000 Property Expenses:70130 Utilities"}
]

export class PartyCombobox extends Component{
	render(){
		let { props } = this
		let party = props.party || {}
		let hasOptional = props.object.paymentMethod != "QuickBooks"?true:
			(props.object.vendorID && props.parties[props.object.vendorID]
			&& props.parties[props.object.vendorID].address
			&& (props.parties[props.object.vendorID].phoneNumber || props.parties[props.object.vendorID].cellNumber)
			&& props.parties[props.object.vendorID].accountNumber)?
			true:false
		return(
			<Combobox
				icon={
					party.firstName && hasOptional?
					party.type == "merchant"?
							<img
								src={'/' + process.env.REACT_APP_NAME + "/static/img/vendor-green.png"}
								style={{
					              width: "20px"
					              , position: "relative"
					              , top: "-2px"
					            }}
							/>
					:party.type == "agent"?
						<img
							src={`/assets/manager/img/agents_g48.png`}
							style={{
							  width: "20px"
							  , position: "relative"
							  , top: "-2px"
							}}
						/>
					:party.type == "repairman"?
						<img
							src={`/assets/manager/img/repairmen_g48.png`}
							style={{
							  width: "20px"
							  , position: "relative"
							  , top: "-2px"
							}}
						/>
					:
						<img
							src={'/' + process.env.REACT_APP_NAME + "/static/img/tenant-green.png"}
							style={{
							  width: "22px"
							  , position: "relative"
							  , top: "0px"
							}}
						/>
					:<i
						className="material-icons"
						style={{
							float: "left"
							, width: "21px"
							, position: "relative"
							, top: "-5px"
							, left: "-3px"
							, color: "orange"
						}}
					>
						arrow_forward
					</i>
				}
				link={`/manager/${party.type == "merchant"?"vendor":party.type}/${party._id}/`}
				text={props.party?props.party.firstName:""}
				hintText={<span>Enter party name</span>}
				noDelete={props.object.qbid || props.object.qbidNew}
				dataSource={
					R.map(party => ({
						text: party.accountNumber
						? `${party.firstName || party.fullName} (acct# ${party.accountNumber})`
						: `${party.firstName || ''}`
					  , value: (
							<MenuItem
							  key={party._id}
							  primaryText={
								  <div key = {`${party._id}-card`}>
									  <div>{(party.fullName)?party.fullName:party.firstName}</div>
									  <div style={{fontSize: "13px", marginTop: "-24px"}}>{party.subtype ? party.subtype:party.type}, account# {(party.accountNumber)?party.accountNumber:"none"}</div>
									  <div style={{fontSize: "13px", marginTop: "-24px", display: (party.propertyID && this.props.properties[party.propertyID]) ? "" : "none"}}>{(party.propertyID && this.props.properties[party.propertyID])? this.props.properties[party.propertyID].alias: ''}</div>
								  </div>
							  }
							/>
						)
					  , id: party._id
				  }), sortSev(props.parties, "firstName"))
				}
				onChange={(party)=>{
					let partyObj = party && props.parties[party.id]
					let newExps = []
					if (party){
						let bkid = partyObj.propertyID && props.properties[partyObj.propertyID] && props.properties[partyObj.propertyID].ownerID || ""
						let cc = R.indexBy(R.prop('subtype'), cats)
						let partiesCategory = partyObj.type == "agent" ? "70000 Property Expenses:70070 Management fees" :
								partyObj.type == "repairman" ? "70000 Property Expenses:70030 Cleaning and maintenance" : partyObj.category ? partyObj.category :
								cc[partyObj.subtype] ? cc[partyObj.subtype].req : ''
						let newEl = {
						  category: partiesCategory,
						  categoryName: "",
						  amount: "",
						  memo: "",
						}
						let newElN = {
						  category: partiesCategory,
						  categoryName: "",
						  half: partyObj && partyObj.propertyID=='5028d898-5ff7-4fd7-eb58-f792eed9c600'?"S Lubarsky":"N Mand",
						  amount: "",
						  memo: ""
						}
						let newElS = {
						  category: partiesCategory,
						  categoryName: "",
						  half: partyObj && partyObj.propertyID=='cdfc6ea4-99e2-4637-92c8-a79b5bb2e670'?"N Mand":"S Lubarsky",
						  amount: "",
						  memo: ""
						}
						newExps = doc.expenses && doc.expenses.length ?
							doc.expenses
							:
							bkid != "1476645611177"?
							  [newEl]
							  :
							  [newElN, newElS]
						}
						props.STAGE({
							_id: props.objectID
						  , party: party && ((partyObj.fullName)?partyObj.fullName:partyObj.firstName)
						  , partyID: party && partyObj._id
						  , partyAccNumber: party && ((partyObj&&partyObj.accountNumber)?partyObj.accountNumber:"not found")
						  , partyType: party && partyObj.type
						  , partyQbid: party && partyObj.partyQbid
						  , vendor: party && ((partyObj.fullName)?partyObj.fullName:partyObj.firstName)
						  , vendorID: party && partyObj._id
						  , vendorAccNumber: party && ((partyObj&&partyObj.accountNumber)?partyObj.accountNumber:"not found")
						  , vendorType: party && partyObj.type
						  , vendorQbid: party && partyObj.partyQbid
						  , address: party && partyObj.addr
						  , expenses: party && (newExps.length ? newExps : [])
						  , memo: party ? partyObj&&partyObj.accountNumber ? "acct# " + partyObj.accountNumber : partyObj.memo ? partyObj.memo : '' : ''
						  , propertyID: party && partyObj.propertyID
						})
					}
				}
			/>
		)
	}
}

export default connect(select, dataActions)(PartyCombobox)



// WEBPACK FOOTER //
// ./src/components/PartyCombobox.js